import pegasus from "../../build/global/js/00-pegasus"

window.jobSearch = (filters) => {
    return {
        isLoading: false,

        init(){
            //this.fetchJobSearch()
        },

        fetchJobSearch(){
            const elements = ['data-pegasus-ajax-content']; 

            this.isLoading = true;

           fetch(this.buildUrl())
            .then(resp => {
                if(resp.ok){
                    console.log(resp.text());
                }
                
            })
            
        },

        buildUrl(){
            let url = window.location.protocol + '//' + window.location.host + '/wp-content/themes/pegasus/job-search.php' +'?';
            let i = 1
            for (const [key, value] of Object.entries(filters)) {
                url += `${key}=${value}`
                if(i < Object.keys(filters).length){
                    url+='&'
                }
                i++
            }

            return url;
        },
    }
}